import React from 'react';

import { SVGComponentProps } from './svg.types';

const TemplateStoreSVG = ({
  size = '1em',
  stroke = 'currentColor',
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M4 1.33325L2 3.99992V13.3333C2 13.6869 2.14048 14.026 2.39052 14.2761C2.64057 14.5261 2.97971 14.6666 3.33333 14.6666H12.6667C13.0203 14.6666 13.3594 14.5261 13.6095 14.2761C13.8595 14.026 14 13.6869 14 13.3333V3.99992L12 1.33325H4Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 4H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.6667 6.66675C10.6667 7.37399 10.3858 8.05227 9.88566 8.55237C9.38556 9.05246 8.70728 9.33341 8.00004 9.33341C7.2928 9.33341 6.61452 9.05246 6.11442 8.55237C5.61433 8.05227 5.33337 7.37399 5.33337 6.66675"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TemplateStoreSVG;
